export default __webpack_public_path__ + "static/media/logo-example-05.b6591c70.jpg";